/**
 * Dynamically loads all color scheme definitions from the `schemes/` directory.
 *
 * Uses Webpack's `require.context` to glob all `.json` files at build time,
 * so adding a new theme requires only dropping a JSON file here - no import
 * or array registration needed.
 *
 * @remarks
 * `require.context` is a Webpack-only API and is not available in Jest.
 * Tests that import `constants.ts` must mock this module:
 * ```ts
 * jest.mock("../schemes", () => ({ __esModule: true, default: [] }));
 * ```
 *
 * @module
 */
import type { SchemeDefinition } from "../types";

const ctx = require.context(".", false, /\.json$/);
const schemeDefs: SchemeDefinition[] = ctx
    .keys()
    .map((key: string) => ctx(key) as SchemeDefinition);

export default schemeDefs;
